// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifications .alert {\n  position: fixed;\n  z-index: 10000;\n}\n.notifications .alert[data-notify=container] {\n  width: 480px;\n  cursor: pointer;\n}\n.notifications .alert.center {\n  left: 0px;\n  right: 0px;\n  margin: 0 auto;\n}\n.notifications .alert.left {\n  left: 20px;\n}\n.notifications .alert.right {\n  right: 20px;\n}", ""]);
// Exports
module.exports = exports;
